
import { IonContent, IonPage, IonGrid, IonRow, IonCol } from '@ionic/vue';
import { useRouter} from "vue-router";

export default {
  name: 'Nutzungsbedingungen',
  setup() {
    return {
      router: useRouter()
    }
  },
  components: {
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonPage
  },
}

